import { UpgradeToWriter } from './UpgradeToWriter'
import { withUpgradeToWriter } from './withUpgradeToWriter'

const ConnectedUpgradeToWriter = withUpgradeToWriter(UpgradeToWriter)
export { ConnectedUpgradeToWriter as UpgradeToWriter }
